// lazy-image-items.ts
//
// Mapowanie listy stron menu na adresy <picture> — wydzielone z komponentu, zeby
// kontrakt adresu dalo sie przetestowac bez TestBed.
//
// Adres = baza + name + rozszerzenie. Baza to `item.basePath`, gdy strona go ma
// (zlozone menu `food`: kartki szefa kuchni leza w innym katalogu niz karta
// glowna), a w przeciwnym razie wspolne `imagesPath` — dokladnie to, co bylo
// przed kompozycja, wiec drink/chef/season renderuja sie bez zmian.

export interface LazyImageSource {
  name: string;
  alt: string;
  basePath?: string | null;
}

export interface LazyImageItem {
  /** Wariant `.jpg` (source image/png w szablonie). */
  name: string;
  /** Wariant `.webp` — ten realnie laduje sie w <img> i <source>. */
  secondName: string;
  alt: string;
}

export function toLazyImageItems(
  list: readonly LazyImageSource[],
  imagesPath: string
): LazyImageItem[] {
  return list.map(item => {
    const base = item.basePath ?? imagesPath;
    return {
      name: base + item.name + '.jpg',
      secondName: base + item.name + '.webp',
      alt: item.alt,
    };
  });
}
